import { render, staticRenderFns } from "./HrPayrollCreate.vue?vue&type=template&id=203b5e27&lang=pug&"
import script from "./HrPayrollCreate.vue?vue&type=script&lang=js&"
export * from "./HrPayrollCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrPayrollCreate.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VIcon,
})
